import React from 'react';
import { NavLink, useNavigate, Navigate } from 'react-router-dom';
import { isLoggedIn, clearToken } from '../../api/adminClient';
import './Admin.css';

const navItems = [
  { label: '회사 정보', path: '/admin/company', icon: 'building' },
  { label: '업무 관리', path: '/admin/events', icon: 'calendar' },
  { label: '채용공고 관리', path: '/admin/jobs', icon: 'briefcase' },
  { label: '문의·견적 접수', path: '/admin/inquiries', icon: 'inbox' },
  { label: '입사지원 접수', path: '/admin/applications', icon: 'users' },
  { label: '프리랜서 관리', path: '/admin/freelancers', icon: 'user-check' },
  { label: '근로계약서 내용 관리', path: '/admin/contract-contents', icon: 'clipboard' },
  { label: '근로계약서 관리', path: '/admin/contracts', icon: 'file-signature' },
  { label: '공지사항 관리', path: '/admin/notices', icon: 'bell' },
  { label: 'FAQ 관리', path: '/admin/faqs', icon: 'help-circle' },
  { label: '매뉴얼', path: '/admin/manual', icon: 'book-open' },
];

export default function AdminLayout({ children }) {
  const navigate = useNavigate();

  if (!isLoggedIn()) {
    return <Navigate to="/admin/login" replace />;
  }

  const handleLogout = () => {
    if (window.confirm('로그아웃하시겠습니까?')) {
      clearToken();
      navigate('/admin/login', { replace: true });
    }
  };

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <div className="admin-sidebar__brand">
          <img src="/logo.png" alt="허브" className="admin-sidebar__logo-img" />
          <div>
            <div className="admin-sidebar__brand-kr">허브 관리자</div>
            <div className="admin-sidebar__brand-en">ADMIN CONSOLE</div>
          </div>
        </div>
        <nav className="admin-sidebar__nav">
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `admin-sidebar__link ${isActive ? 'admin-sidebar__link--active' : ''}`}
            >
              <AdminIcon name={item.icon} />
              {item.label}
            </NavLink>
          ))}
        </nav>
        <button className="admin-sidebar__logout" onClick={handleLogout}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          로그아웃
        </button>
        <a href="/" className="admin-sidebar__back">← 홈페이지로 돌아가기</a>
      </aside>
      <main className="admin-main">{children}</main>
    </div>
  );
}

function AdminIcon({ name }) {
  const icons = {
    building: <><rect x="3" y="3" width="18" height="18" rx="1"/><path d="M8 6h.01M12 6h.01M16 6h.01M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01"/></>,
    'help-circle': <><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></>,
    calendar: <><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></>,
    briefcase: <><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></>,
    inbox: <><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></>,
    users: <><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></>,
    'file-signature': <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><path d="M8 16s1.5-1 2.5 0 1.5 1 2.5 0"/></>,
    'user-check': <><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/></>,
    bell: <><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 01-3.46 0"/></>,
    'book-open': <><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></>,
    clipboard: <><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></>,
  };
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      {icons[name]}
    </svg>
  );
}
